import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';

@Component({
	selector: 'app-tourism-events-link',
	templateUrl: './tourism-events-link.component.html',
	styleUrls: ['./tourism-events-link.component.css'],
})
export class TourismEventsLinkComponent implements OnDestroy {
	@Input() eventId: string = null;
	@Output() changed = new EventEmitter();
	yesNoQuestion = '';
	deleteId = '';
	event2: string = null;
	loader = false;
	data: Array<any> = [];
	tableRows = [
		{
			id: 'event1Link',
			name: 'Wydarzenie 1',
			link: true,
			target: '_blank',
		},
		{
			id: 'event2Link',
			name: 'Wydarzenie 2',
			link: true,
			target: '_blank',
		},
	];
	private questionSubscription;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
	) {}

	ngOnDestroy(): void {
		if (this.questionSubscription) {
			this.questionSubscription.unsubscribe();
		}
	}

	linkOpen() {
		new Modal(document.getElementById('linkEventDialog')).show();
		this.loadData();
	}

	private loadData() {
		this.api.get('/tourismEventsLinks/' + this.eventId + '/', (result, error) => {
			if (error) {
				return;
			}
			result.data.forEach((pos) => {
				pos.event1Link = {
					link: '/tourism-events/' + pos.event1,
					label: pos.event1Name,
				};
				pos.event2Link = {
					link: '/tourism-events/' + pos.event2,
					label: pos.event2Name,
				};
			});
			this.data = result.data;
		});
	}

	linkClose() {
		const modal = Modal.getInstance(document.getElementById('linkEventDialog'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	linkSave() {
		this.event2 = this.event2.substring(this.event2.lastIndexOf('/') + 1);
		this.loader = true;
		this.api.post('/tourismEventsLinks/', { event1: this.eventId, event2: this.event2 }, (result, error) => {
			this.loader = false;
			if (error) {
				return;
			}
			this.event2 = '';
			this.loadData();
		});
	}

	deleteAsk(data) {
		this.question.ask('Czy na pewno usunąć?');
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (!result.result) {
				return;
			}
			this.api.del(
				'/tourismEventsLinks/' + data.id + '/' + data.event1 + '/' + data.event2 + '/',
				(result, error) => {
					if (error) {
						return;
					}
					this.loadData();
				},
			);
		});
	}
}
